// Logger simples para frontend (browser)

export const logger = {
  error: (..._args: any[]) => {},
  warn: (..._args: any[]) => {},
  info: (..._args: any[]) => {},
  debug: (..._args: any[]) => {},
};

export const createLogger = (_context: string) => ({
  error: (..._args: any[]) => {},
  warn: (..._args: any[]) => {},
  info: (..._args: any[]) => {},
  debug: (..._args: any[]) => {},
});

export default logger;
